<template>
  <div class="pc-video-page">
    <section v-if="topVideos.length" class="pc-container top-videos">
      <article v-for="item in topVideos" :key="item.id" @click="goDetail(item)">
        <div class="video-cover">
          <img :src="item.coverImage" :alt="item.title">
          <span class="play-button">▶</span>
        </div>
        <h2>{{ item.title }}</h2>
        <time>{{ formatDate(item) }}</time>
      </article>
    </section>

    <section class="pc-container video-list">
      <div v-if="loading" class="empty">加载中...</div>
      <div v-else-if="!videoList.length" class="empty">暂无视频</div>
      <article v-for="item in videoList" :key="item.id" class="video-row" @click="goDetail(item)">
        <div class="date-box">
          <strong>{{ monthDay(item) }}</strong>
          <span>{{ year(item) }}</span>
        </div>
        <div class="row-content">
          <h2>{{ item.title }}</h2>
          <p>{{ item.summary }}</p>
        </div>
        <span class="row-play">▶</span>
      </article>
    </section>
  </div>
</template>

<script>
  import { getPcPublicVideoList } from '@/api/pc'
  import commerce from '@/utils/pcCommerce'
  import { buildPcDetailPath } from '@/utils/pcRouteCode'

  export default {
    name: 'PcVideoList',
    data() {
      return {
        loading: false,
        videoList: []
      }
    },
    computed: {
      topVideos() {
        return this.videoList.filter(item => item.isTop === 1).slice(0, 3)
      }
    },
    created() {
      this.loadVideos()
    },
    methods: {
      loadVideos() {
        this.loading = true
        getPcPublicVideoList({ page: 1, pageSize: 20 }).then(data => {
          const records = data && data.records ? data.records : []
          this.videoList = records.map(commerce.normalizePcVideo)
        }).catch(() => {
          this.videoList = []
        }).finally(() => {
          this.loading = false
        })
      },
      dateText(item) {
        return String(item.createdAt || item.updatedAt || '').replace('T', ' ').slice(0, 10)
      },
      formatDate(item) {
        return this.dateText(item)
      },
      monthDay(item) {
        const value = this.dateText(item)
        return value.length >= 10 ? value.slice(5, 10) : ''
      },
      year(item) {
        const value = this.dateText(item)
        return value.length >= 4 ? value.slice(0, 4) : ''
      },
      goDetail(item) {
        this.$router.push(buildPcDetailPath('video', item.id))
      }
    }
  }
</script>

<style scoped>
  .pc-video-page {
    min-height: calc(100vh - 206px);
    padding: 36px 0 70px;
    background: #fff;
  }

  .top-videos {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 32px;
  }

  .top-videos article {
    height: 264px;
    background: #f3f3f3;
    cursor: pointer;
  }

  .video-cover {
    position: relative;
    height: 200px;
  }

  .video-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .play-button,
  .row-play {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: rgba(17, 24, 39, .66);
    color: #fff;
  }

  .play-button {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 46px;
    height: 46px;
    padding-left: 3px;
    transform: translate(-50%, -50%);
  }

  .top-videos h2 {
    margin: 8px 10px 0;
    font-size: 15px;
    font-weight: 400;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .top-videos time {
    display: block;
    margin: 14px 10px 0;
    text-align: right;
    color: #9099a8;
  }

  .video-list {
    margin-top: 20px;
    border-top: 1px solid #eee;
  }

  .video-row {
    min-height: 108px;
    display: grid;
    grid-template-columns: 150px minmax(0, 1fr) 56px;
    align-items: center;
    gap: 20px;
    border-bottom: 1px solid #eee;
    cursor: pointer;
  }

  .date-box {
    text-align: center;
    color: #8a8f99;
  }

  .date-box strong,
  .date-box span {
    display: block;
  }

  .date-box strong {
    font-size: 22px;
    font-weight: 400;
  }

  .row-content {
    min-width: 0;
  }

  .row-content h2 {
    margin: 0 0 10px;
    color: #27364a;
    font-size: 18px;
    font-weight: 400;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .row-content p {
    margin: 0;
    color: #5c6678;
    line-height: 24px;
  }

  .row-play {
    width: 34px;
    height: 34px;
    padding-left: 2px;
    background: #1684ff;
    font-size: 13px;
  }

  .empty {
    padding: 80px 0;
    text-align: center;
    color: #8a8f99;
  }
</style>
